import loadable from '@loadable/component';

const GoogleNative = IS_NATIVE
  ? loadable(() => import('./GoogleNative'))
  : () => null;

export { GoogleNative };
